import {FlagsmithClientProvider} from '@openfeature/flagsmith-client-provider';
import {config} from "./config";

export const flagsmithClientProvider = new FlagsmithClientProvider({
  api: config.flagsmith_api,
  environmentID: config.flagsmith_env
});